/*
 * File: Login.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Provides styles for the login view
 */
import { createStyles, Theme } from "@material-ui/core";
import backgroundImage from "images/MPMobileBackground.png";

const styles = (theme: Theme) =>
  createStyles({
    loginPage: {
      position: "relative",
      // 100vh is probably the correct choice semantically here, but iOS safari's disappearing window chrome causes the viewport height to change in a way that isn't reflected in the vh unit. Using "height: 100%;" maintains the current size as long as the elements containing this one also use `height: 100%`.
      height: "100%",
      textAlign: "center",
      padding: theme.spacing(2.5),
      paddingTop: 0,
      paddingBottom: 0,
      backgroundImage: `url(${backgroundImage})`,
      backgroundDimension: "contain",
      display: "flex",
      flexDirection: "column"
    },
    loginContainer: {
      height: "100%",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center"
    },
    logoSpacer: {
      // This spacer should shrink before any of the other elements but should grow very slowly
      flex: "3 3",
      maxHeight: theme.spacing(20),
      width: "100%"
    },
    formSpacer: {
      flex: "1 3",
      maxHeight: theme.spacing(5)
    },
    display2: {
      color: theme.palette.common.white
    },
    display1: {
      marginTop: 0,
      marginBottom: theme.spacing(1),
      color: theme.palette.common.white,
      fontSize: "1.6em"
    },
    troubleSpacer: {
      // This spacer should shrink or grow only when it absolutely needs to
      flex: "1 1",
      maxHeight: theme.spacing(2.5)
    },
    havingTrouble: {
      marginTop: theme.spacing(1),
      textAlign: "center"
    },

    helpSpacer: {
      // This spacer should can shrink but doesn't need to grow.
      flex: "1 2",
      maxHeight: theme.spacing(5)
    },
    helpLinks: {
      marginTop: theme.spacing(1),
      letterSpacing: ".05em"
    },
    copyrightSpacer: {
      // This spacer should do the majority of the shrinking and growing for the view
      flex: "2 4"
    },
    copyrightBlurb: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      width: "90%"
    },
    acknowledgments: {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
      textAlign: "center",
      fontSize: "0.8em"
    }
  });

export default styles;
